export default "__VITE_PUBLIC_ASSET__fe966c3d__"